import React from "react";
import { Box, Typography } from "@mui/material";
import { palette } from "../../theme";

// Consistent page header: title + subtitle on the left, action buttons on the right.
export default function PageHeader({ title, subtitle, actions }) {
  return (
    <Box
      sx={{
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 2,
        mb: 3,
      }}
    >
      <Box>
        <Typography variant="h4" sx={{ color: palette.text }}>
          {title}
        </Typography>
        {subtitle && (
          <Typography variant="body1" sx={{ color: palette.textSecondary, mt: 0.5 }}>
            {subtitle}
          </Typography>
        )}
      </Box>
      {actions && (
        <Box sx={{ display: "flex", gap: 1.5, flexWrap: "wrap" }}>{actions}</Box>
      )}
    </Box>
  );
}
